namespace GeniuzPOS.Common.Helpers {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class PurApproveFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];

            if (chanel == 0) {
                return  "<button class='btn btn-sm' style='background-color:rgb(255, 255, 255); color:rgb(255, 255, 255); border: none;'></button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-check-square' style='color:#2E8B57'></i> " +
                    "<button class='btn btn-sm' style='background-color: #98FB98; color: #2E8B57; border: none;'>อนุมัติแล้ว</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-times-circle' style='color:#CD5C5C'></i> " +
                    "<button class='btn btn-sm' style='background-color: #FFB6C1; color: #CD5C5C; border: none;'>Reject</button>";
            } else if (chanel == 3) {
                return "<i class='fa fa-undo' style='color:#DAA520'></i> " +
                    "<button class='btn btn-sm' style='background-color: #FFE4B5; color: #DAA520; border: none;'>ส่งกลับแก้ไข</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }


    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class SendAppFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];

             if (chanel == 0) {
                return 
                // "<i class='fa fa-check text-success'></i> "
                //  +
                       "<button class='btn btn-sm' style='background-color:rgb(255, 255, 255); color:rgb(255, 255, 255); border: none;'></button>";
            } else
            if (chanel == 1) {
                return "<i class='fa fa-check-square' style='color:rgb(139, 139, 46)'></i> " +
                    "<button class='btn btn-sm' style='background-color:rgb(255, 255, 146); color:rgb(139, 139, 46); border: none;'>รออนุมัติ</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }
    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class POTypeFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];

            if (chanel == 0) {
                return "<i class='fa fa-credit-card' style='color:#4169E1'></i> " +
                    "<button class='btn btn-sm' style='background-color: #ADD8E6; color: #4169E1; border: none;'>สินค้าเครดิต</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-handshake-o' style='color:#DAA520'></i> " +
                    "<button class='btn btn-sm' style='background-color: #FFE4B5; color: #DAA520; border: none;'>สินค้าฝากขาย</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }



    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class UseFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];

            if (chanel == 0) {
                return "<i class='fa fa-clock-o' style='color:rgb(153, 88, 2)'></i> " +
                    "<button class='btn btn-sm' style='background-color:rgb(255, 191, 107); color:rgb(159, 159, 159); border: none;'>ยังไม่ใช้งาน</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-hourglass-half' style='color:rgb(149, 142, 43)'></i> " +
                    "<button class='btn btn-sm' style='background-color:rgb(249, 255, 133); color:rgb(149, 142, 43); border: none;'>ค้างบางส่วน</button>";
            } else if (chanel == 1) {
                return "<i class='fa fa-hourglass-half' style='color:rgb(70, 180, 90)'></i> " +
                    "<button class='btn btn-sm' style='background-color:rgb(186, 254, 188); color:rgb(70, 180, 90); border: none;'>Close</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter, Serenity.IInitializeColumn])
    export class PurCancelFgFormatter implements Slick.Formatter {

        format(ctx: Slick.FormatterContext) {
            var text = Q.htmlEncode(ctx.value);

            if (!this.chanalPropertyId) {
                return text;
            }

            let chanel = ctx.item[this.chanalPropertyId];

            if (chanel == 0) {
                return 
                // "<i class='fa fa-check text-success'></i> "
                //  +
                       "<button class='btn btn-sm' style='background-color:rgb(255, 255, 255); color:rgb(255, 255, 255); border: none;'></button>";
            } else
            if (chanel == 1) {
                return "<i class='fa fa-times' style='color:rgb(153, 88, 2)'></i> " +
                    "<button class='btn btn-sm' style='background-color:rgb(255, 191, 107); color:rgb(153, 88, 2); border: none;'>ยกเลิก</button>";
            } else if (chanel == 2) {
                return "<i class='fa fa-hourglass-half' style='color:rgb(149, 142, 43)'></i> " +
                    "<button class='btn btn-sm' style='background-color:rgb(249, 255, 133); color:rgb(149, 142, 43); border: none;'>กำลังดำเนินการ</button>";
            } else {
                return chanel;
            }
        }

        @Serenity.Decorators.option()
        public chanalPropertyId: string;

        public initializeColumn(column: Slick.Column) {
            column.referencedFields = column.referencedFields || [];
            if (this.chanalPropertyId)
                column.referencedFields.push(this.chanalPropertyId);
        }
    }





}